<template>
    <div class="xzt-all">
        <div class="header">
            <div class="header-left">
                总结算 <template v-if="userType == 0"><span style="color:#f56c6c;">澳门</span></template>
                <template v-else>香港</template>
                <el-button type="danger" @click="onChangeType(0)" style="margin-left: 10px;">澳门</el-button>
                <el-button type="primary" @click="onChangeType(1)">香港</el-button>

            </div>
            <div class="header-right">
                <el-button type="primary" @click="onTools">操作</el-button>
                <el-button type="primary" @click="onCopy">复制数据</el-button>
                <el-button type="primary" @click="onBack">返回</el-button>
            </div>
        </div>
        <div class="main">
            <div class="container one">
                <div class="section">
                    <el-table ref="tableArr" :data="lists2" style="width: 100%;overflow-x: auto;"
                        :cell-style="changeCellStyle2">
                        <template v-for="item in items2">

                            <el-table-column v-if="item.id == 'name'" :label="item.name" :prop="item.id" fixed="right"
                                width="160" align="center">
                                <template slot-scope="scope">
                                    <div :class="scope.row.isJQ ? 'title2 red' : 'title2 green'">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column v-else-if="item.id == 'total'" :label="item.name" :prop="item.id"
                                fixed="right" width="160" align="center">
                                <template slot-scope="scope">
                                    <div :class="`title ${scope.row.total > 2000 ? 'red1' : ''}`">
                                        {{ scope.row.total }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column v-else :key="item.name" width="100" header-align="center" align="center"
                                :label="item.name" :prop="item.id"></el-table-column>
                        </template>
                    </el-table>
                </div>
                <div class="section">
                    <el-table ref="tableArr" :data="lists3" style="width: 100%;overflow-x: auto;"
                        :cell-style="changeCellStyle3">
                        <template v-for="item in items2">
                            <el-table-column v-if="item.id == 'name'" :label="item.name" :prop="item.id" fixed="right"
                                width="160" align="center">
                                <template slot-scope="scope">
                                    <div class="title2">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column v-else-if="item.id == 'total'" :label="item.name" :prop="item.id"
                                fixed="right" width="160" align="center">

                                <template slot-scope="scope">
                                    <div :class="`title ${scope.row.total > 2000 ? 'red1' : ''}`">
                                        {{ scope.row.total }}
                                    </div>
                                </template>

                            </el-table-column>
                            <el-table-column v-else :key="item.name" width="100" header-align="center" align="center"
                                :label="item.name" :prop="item.id"></el-table-column>
                        </template>
                    </el-table>
                </div>
            </div>
            <div class="container two" style="margin-top:10px;">
                <el-table ref="tableArr" :data="lists" style="width: 100%;overflow-x: auto;"
                    :cell-style="changeCellStyle">
                    <template v-for="item in items">
                        <el-table-column v-if="item.id == 'index'" :label="item.name" :prop="item.id" fixed="right"
                            width="120" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.$index === lists.length - 2">
                                    总计：
                                </span>
                                <span v-else-if="scope.$index === lists.length - 1">
                                    水：
                                </span>
                                <span v-else>
                                    {{ scope.$index + 1 }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column v-else-if="item.id == 'num'" :label="item.name" :prop="item.id" fixed="right"
                            width="120" align="center">
                            <template slot-scope="scope">
                                <div :class="`title ${scope.row.color}`">
                                    {{ scope.row.num }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column v-else-if="item.id == 'total' || item.id == 'douyu'" :label="item.name"
                            :prop="item.id" fixed="right" width="120" align="center"></el-table-column>
                        <el-table-column v-else :key="item.name" width="100" header-align="center" align="center"
                            :label="item.name" :prop="item.id"></el-table-column>
                    </template>
                </el-table>
            </div>

        </div>
        <tools ref="tools" @close="onToolsClose"></tools>
    </div>
</template>
<script>
import { getColor, getSX } from "./num.js";
import Tools from "./tools.vue";
//尾数  13 开始 0尾 以此类推
//生肖  type 1-12
export default {
    name: 'all',
    components: {
        Tools
    },
    data() {
        return {
            isRequest:false,
            userType: 0,
            lists: [

            ],
            lists2: [],
            lists3: [],
            items: [
                // { name: "序号", id: "index" },
                // { name: "号码", id: "num" },
                // { name: "需投注", id: "douyu" },
                // { name: "总金额", id: "total" },
            ],
            items2: [
                // { name: "序号", id: "index" },
                // { name: "号码", id: "num" },
                // { name: "需投注", id: "douyu" },
                // { name: "总金额", id: "total" },
            ],
            totalPrice: 0,
            totalPrice2: 0,
            totalPrice3: 0,
            txtCopy: "",
            windowHeight: 0,
            tlists: [],
            jq: ["牛", "马", "鸡", "羊", "狗", "猪"]
        };
    },
    mounted() {
        this.updateWindowHeight();
        window.addEventListener('resize', this.updateWindowHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowHeight);
    },
    created() {


        this.requestData();
    },
    methods: {
        onChangeType(value) {
            this.userType = value;
            this.requestData();
        },
        onTools() {
            this.$refs["tools"].show(this.tlists);
        },
        onCopy() {
            this.$copyText(this.txtCopy).then(
                (e) => {
                    alert("复制成功");
                    console.log(e);
                }, (e) => {
                    alert("复制失败");
                    console.log(e);
                }
            );

        },
        updateWindowHeight() {
            this.windowHeight = window.innerHeight;
        },
        changeCellStyle2(value) {
            if (value.rowIndex == this.lists2.length - 1) {
                return 'height:43px;padding:0;background:#ddd;text-align:center;color:red;font-weight:bold;font-size:16px;'
            }
            return 'height:43px;padding:0;background:white;text-align:center;'

        },
        changeCellStyle3(value) {
            if (value.rowIndex == this.lists3.length - 1) {
                return 'height:35px;padding:0;background:#ddd;text-align:center;color:red;font-weight:bold;font-size:16px;'
            }
            return 'height:35px;padding:0;background:white;text-align:center;'

        },
        changeCellStyle(value) {
            //列的label的名称
            if (value.rowIndex == this.lists.length - 1 || value.rowIndex == this.lists.length - 2) {
                return 'background:white;height:25px;padding:0;color:red;font-weight:bold;font-size:18px;text-align:center;'
            } else if (value.columnIndex === this.items.length - 2) {
                return 'color:black;background:orange;font-weight:bold;font-size:16px;height:25px;padding:0;text-align:center;' //修改的样式
            } else if (value.rowIndex === 6) {
                return 'background:#fee6e6;height:30px;padding:0;text-align:center;'
            }
            else if (value.rowIndex === 21) {
                return 'background:#ddd;height:30px;padding:0;text-align:center;'
            } else if (value.rowIndex === 36) {
                return 'background:#e9fee6;height:30px;padding:0;text-align:center;'
            } else {
                return 'height:25px;padding:0;background:white;text-align:center;'
            }

        },

        initData() {
            this.lists = [];
            for (var i = 1; i < 50; i++) {
                let color = getColor(i);
                this.lists.push({
                    index: i,
                    num: i,
                    color: color,
                    douyu: 0,
                    total: 0,
                })
            }
            let sx = getSX();
            this.lists2 = [];
            this.lists3 = [];

            for (var i = 0; i < 12; i++) {
                if (i < 10) {
                    this.lists3.push({
                        name: i + "尾",
                        total: 0,
                    })
                }
                let isJQ = this.jq.includes(sx[i]);
                this.lists2.push({
                    name: sx[i],
                    total: 0,
                    isJQ: isJQ,
                })
            }
        },
        requestData() {
            if(this.isRequest == true) return;

            this.isRequest = true;
            this.initData();
            this.totalPrice = 0;
            this.totalPrice2 = 0;
            this.totalPrice3 = 0;
            let self = this;

            this.$http.get("/admin/xzt/all?userType=" + this.userType).then((res) => {
                self.items = [];
                self.items2 = [];
                self.totalPrice = 0;
                self.txtCopy = "";
                //self.lists = [];
                var values = res.data;
                for (var i = 0; i < values.length; i++) {
                    let nitem = values[i];
                    let key = nitem.id + "-" + nitem.username;
                    self.items.push({ name: nitem.username, id: key });
                    self.items2.push({ name: nitem.username, id: key });
                }
                self.items.push({ name: "序号", id: "index" });
                self.items.push({ name: "号码", id: "num" });
                self.items.push({ name: "需投注", id: "douyu" });
                self.items.push({ name: "总金额", id: "total" });
                self.items2.push({ name: "名称", id: "name" });
                self.items2.push({ name: "总金额", id: "total" });

                for (var i = 0; i < values.length; i++) {
                    let nitem = values[i];
                    let key = nitem.id + "-" + nitem.username;

                    let xzt = nitem.xzt;
                    for (var j = 0; j < xzt.length; j++) {
                        let xitem = xzt[j];
                        let num = xitem.num;//序号
                        let item = self.lists[num - 1];
                        // console.log("item:", item,"key:",key,"num:",num);
                        item[key] = xitem.value;
                        item["total"] = item["total"] + xitem.value;
                        self.lists[num - 1] = item;
                    }
                    let statics = nitem.statics;
                    for (var j = 0; j < statics.length; j++) {
                        let sitem = statics[j];
                        let num = sitem.type;
                        if (num < 13) {
                            let item = self.lists2[num - 1];
                            // console.log("item:",item,"key:",key,"num:",num);
                            item[key] = sitem.value;
                            item["total"] = item["total"] + sitem.value;
                            self.lists2[num - 1] = item;
                        } else {
                            let item = self.lists3[num - 13];
                            item[key] = sitem.value;
                            item["total"] = item["total"] + sitem.value;
                            self.lists3[num - 13] = item;
                        }

                    }

                }


                for (var i = 0; i < self.lists.length; i++) {
                    let item = self.lists[i];
                    let total = item.total;
                    self.totalPrice = self.totalPrice + total;
                }
                let averagePrice = parseInt(this.totalPrice / 45);
                let douyu = 0;
                for (var i = 0; i < self.lists.length; i++) {
                    let item = self.lists[i];
                    let total = item.total;
                    let v = total - averagePrice;
                    if (v < 0) {
                        v = 0;
                    }
                    item.douyu = v;

                    douyu = item.douyu + douyu
                }


                let bb = self.lists.sort((b, a) => {
                    // console.log("b:", b, "a:", a);
                    return parseInt(a.total) - parseInt(b.total);
                });

                //复制内容的
                this.tlists = [];
                for (var j = 0; j < self.lists.length; j++) {
                    if (j < 21) {

                        let value = self.lists[j].num < 10 ? "0" + self.lists[j].num : self.lists[j].num;
                        this.tlists.push({
                            num: value,
                            value: self.lists[j].douyu,
                        });
                        console.log("value:", value);
                        this.txtCopy = this.txtCopy + value + " --- " + self.lists[j].douyu + "\n";
                    }
                }

                for (var i = 0; i < self.lists2.length; i++) {
                    let item = self.lists2[i];
                    let total = item.total;
                    self.totalPrice2 = self.totalPrice2 + total;
                }
                for (var i = 0; i < self.lists3.length; i++) {
                    let item = self.lists3[i];
                    let total = item.total;
                    self.totalPrice3 = self.totalPrice3 + total;
                }

                this.lists.push({
                    index: "总计",
                    douyu: douyu,
                    total: this.totalPrice,
                });
                this.lists.push({
                    index: "水",
                    douyu: "",
                    total: parseInt(this.totalPrice * 0.08),
                });
                console.log("leng:", this.lists.length);

                this.lists2.push({
                    name: "总计",
                    total: this.totalPrice2,
                })
                this.lists3.push({
                    name: "总计",
                    total: this.totalPrice3,
                })

                this.isRequest = false;
                // console.log("bb:", bb);
            });
        },
        onBack() {
            this.$router.push('/xzt');
        }
    }
}
</script>
<style scoped>
.xzt-all {
    width: 100%;
    /* height: 100vh; */
    background-color: #f5f5f5;



    .header {
        width: 100%;
        height: 60px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: linear-gradient(to right, #0f6ad7, #00ced4);
        color: #fff;
        position: fixed;
        top: 0;
        z-index: 100;

        .header-left {
            flex: 1;
            font-size: 20px;
            text-align: center;
            width: calc(100% - 100px);
            display: inline-block;
        }

        .header-right {
            flex: none;
            width: 300px;
            display: inline-block;
        }

    }

    .main {
        width: 100%;
        margin-top: 50px;
        /* max-width: 1200px; */
        /* height: calc(100vh - 60px); */
        /* overflow-y: scroll; */
        display: flex;
        flex-direction: row;
        /* margin: 0 auto; */
        padding: 10px;
        box-sizing: border-box;

        .container {
            margin: 0 auto;

            &.one {
                width: 38%;
                margin-right: 2%;
            }

            &.two {
                width: 59%;
            }

            .section {
                margin-top: 10px;
            }

            .title2 {
                font-size: 20px;
                font-weight: bold;
                color: black;

                &.red {
                    color: blue;
                }

                &.green {
                    color: green;
                }
            }

            .title {
                font-size: 20px;
                font-weight: bold;

                &.red {
                    color: rgb(245, 140, 140);
                }

                &.red1 {
                    color: red;
                }

                &.blue {
                    color: rgb(118, 118, 242);
                }

                &.green {
                    color: rgb(64, 209, 64);
                }
            }
        }


    }


    @media screen and (max-width: 768px) {
        .main {
            flex-direction: column;

            .container {
                width: 100%;
                margin: 0;

                &.one {
                    width: 100%;
                    margin-right: 0;
                }

                &.two {
                    width: 100%;
                }
            }
        }
    }
}
</style>